import { NavigationApi } from '@appfolio/backstage-plugin-navigation-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const navigationApiRef = createApiRef<NavigationApi>({
  id: 'plugin.navigation.service',
});
